import { Grid } from "@mui/material";

import Image from "../../../Image/Image";
import { BottomSelector } from "../BottomSelector/BottomSelector";

import { DashboardDialog } from "@/dashboard-design-system/Dialog";
import { DashboardIconButton } from "@/dashboard-design-system/IconButton";
import { ChevronRight, ChevronLeft, Cross as Close } from "@/icons/outlined";

interface FullScreenDesktopImageDisplayProps {
  photoUrls: string[];
  title?: string;
  onClose: () => void;
  displayedImageIndex: number;
  goLeft: () => void;
  goRight: () => void;
  setSelectedIndex: (index: number) => void;
}

export const FullScreenDesktopImageDisplay = ({
  photoUrls,
  title,
  onClose,
  displayedImageIndex,
  goLeft,
  goRight,
  setSelectedIndex,
}: FullScreenDesktopImageDisplayProps) => {
  const size = 538;
  const hasMultipleImages = photoUrls.length > 1;
  const buttonSize = 42;
  const buttonOffset = size / 2 + buttonSize + 20;

  return (
    <DashboardDialog
      onClose={onClose}
      open={true}
      sx={{
        [`.MuiPaper-root`]: {
          backgroundColor: "unset",
          boxShadow: "unset",
        },
      }}
    >
      <Grid item sx={{ position: "fixed", marginTop: 4, marginRight: 4, top: 0, right: 0 }}>
        <DashboardIconButton size="large" vibe="neutral" variant="tonal" onClick={onClose}>
          <Close />
        </DashboardIconButton>
      </Grid>
      <Grid sx={{ position: "fixed", left: `calc(50% - ${buttonOffset}px)`, top: `calc(50% - ${buttonSize}px)` }}>
        <DashboardIconButton
          size="large"
          vibe="neutral"
          variant="tonal"
          disabled={displayedImageIndex === 0}
          onClick={goLeft}
        >
          <ChevronLeft />
        </DashboardIconButton>
      </Grid>
      <Grid sx={{ position: "fixed", right: `calc(50% - ${buttonOffset}px)`, top: `calc(50% - ${buttonSize}px)` }}>
        <DashboardIconButton
          size="large"
          vibe="neutral"
          variant="tonal"
          disabled={displayedImageIndex + 1 >= photoUrls.length}
          onClick={goRight}
        >
          <ChevronRight />
        </DashboardIconButton>
      </Grid>
      <Grid item>
        <Grid container sx={{ width: size, position: "relative" }}>
          <Grid
            item
            xs={12}
            sx={{ position: "relative", overflow: "hidden", width: size, height: size, borderRadius: 4 }}
          >
            <Grid
              container
              direction="row"
              sx={{
                position: "absolute",
                top: 0,
                left: -size * displayedImageIndex,
                height: size,
                width: size * 3,
                transition: "left 0.2s ease-in-out",
              }}
            >
              {photoUrls.map((photoUrl, index) => (
                <Grid item key={index + photoUrl}>
                  <Image
                    nextImage
                    src={photoUrl}
                    alt={title ? `${title} item` : "item"}
                    width={size}
                    height={size}
                    objectFit="cover"
                    data-test="rate-image"
                    resolution={size * 2}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
        {hasMultipleImages && (
          <Grid item marginTop={3}>
            <BottomSelector
              displayedImageIndex={displayedImageIndex}
              goLeft={goLeft}
              goRight={goRight}
              photoUrls={photoUrls}
              setSelectedIndex={setSelectedIndex}
              size="medium"
              noArrows
            />
          </Grid>
        )}
      </Grid>
    </DashboardDialog>
  );
};
